/**
 * Campaigns (beta) — what we send out, and what came of it.
 *
 * Lee, 7 Oct 2026: the outreach report has grown past a tab in Analytics ("this is now a
 * broader tool that's using hubspot data and supplementing it with our engagement and
 * redirect info … a separate Campaigns tool … we can also extend it later to other campaigns
 * and bring in the ad work"), and: "you can build and write a beta campaign tool in tools".
 *
 * It owns nothing. Each campaign here is a report that already exists as a shared component
 * (the conveyancer email outreach; the paid-social ads), given one home. The same reports stay
 * where they were, in Analytics and Engagement, fed by the same hooks, so none can disagree.
 */
import { FaBullhorn } from 'react-icons/fa';
import { BaseTool } from '../BaseTool';

export class CampaignsTool extends BaseTool {
  constructor() {
    super();
    this.id = 'campaigns';
    this.name = 'Campaigns (beta)';
    this.description = 'What we send out, and what came of it: the email outreach and the ads';
    this.icon = FaBullhorn;
    // Violet: an identity of its own beside Analytics' cyan and Engagement's indigo, and clear
    // of the green, amber and red the reports use to MEAN something, and of the ORANGE that
    // means "an estimate" on the outreach report (Critical Rule 1b).
    this.color = '#6d28d9';
    this.path = '/dashboard/tools/campaigns';
    // Reads outreach_snapshots (through getOutreachReport) and what Analytics reads; owns nothing.
    this.collections = [];
    this.requiresAdmin = false;
    // Hidden until each person switches it on in their profile, as Analytics (beta) is: a
    // colleague's menu does not change because a beta tool was published.
    this.hiddenByDefault = true;
  }

  async getSummaryData() {
    return { success: true, data: {}, lastUpdated: new Date() };
  }
}
